import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { OverlayModule } from '@angular/cdk/overlay';
import {
  ApplicationConfig,
  DEFAULT_CURRENCY_CODE,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, TitleStrategy, withInMemoryScrolling } from '@angular/router';
import { provideOAuthClient } from 'angular-oauth2-oidc';

import { AuthService } from './auth/services/http/auth/auth';
import { AppTitleStrategy } from './app-title.strategy';
import { routes } from './app.routes';
import { apiErrorInterceptor } from '@core/interceptors/api-error.interceptor';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { loadingInterceptor } from '@core/interceptors/loading.interceptor';
import { provideEnvironmentNgxMask, provideNgxMask } from 'ngx-mask';
import { provideDialogConfig } from 'ng-primitives/dialog';

registerLocaleData(localePt, 'pt-BR');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    importProvidersFrom(OverlayModule),
    ...provideDialogConfig({
      closeOnEscape: true,
      closeOnClick: true,
      closeOnNavigation: true,
      modal: true,
    }),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
    ),
    provideHttpClient(
      withInterceptors([
        apiErrorInterceptor,
        authInterceptor,
        loadingInterceptor,
      ]),
    ),
    provideOAuthClient(),
    provideEnvironmentNgxMask({
      dropSpecialCharacters: true,
    }),
    provideAppInitializer(() => inject(AuthService).initOAuth2()),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    provideNgxMask({ dropSpecialCharacters: true }),
  ],
};
